import { BodyText } from '@postscript/components';
import React from 'react';
import styled from 'styled-components';

interface LinkValueProps {
  children: React.ReactNode;
  // When true, render the value as a single-line, ellipsis-truncated string.
  // Used for long unbreakable values (e.g. Content URLs) that would otherwise
  // blow out the row layout. Default (false) keeps the multi-line wrapping
  // behavior used by rows like Tactic.
  truncate?: boolean;
  // Native tooltip surfaced on hover — pass the full value when truncating so
  // the elided text is still discoverable.
  title?: string;
}

// styled-component variant of BodyText that clamps to a single ellipsized
// line. Kept separate so the default (non-truncated) LinkValue renders exactly
// as before.
const TruncatedLink = styled(BodyText).attrs({
  size: 'small',
  color: 'var(--link-color)',
})`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  max-width: 100%;
`;

// Blue-link styled value used for navigable inputs (Tactic Group, Tactic).
// Visual only — the row owns the click handler.
export const LinkValue: React.FC<LinkValueProps> = ({
  children,
  truncate = false,
  title,
}) => {
  if (truncate) {
    return <TruncatedLink title={title}>{children}</TruncatedLink>;
  }

  return (
    <BodyText size="small" color="var(--link-color)" title={title}>
      {children}
    </BodyText>
  );
};
